import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

import styles from '../../styles/components/UI/Image.module.css'

const Image = React.memo(function Image(props) {
  return <Img {...props} placeholderClassName={styles.placeholder} />
})

Image.propTypes = {
  className: PropTypes.string
}

export default Image
